<component-modal showClose="false">
  <ng-container title>0docs documents</ng-container>

  <ng-container body>
    <div class="content-wrap">
      <component-input
        [(ngModel)]="searchValue"
        [placeholder]="'Search documents'"
        [floating]="false"
        [secondary]="true"
        class="w-100"
        [isClearable]="true"
        [prefixIcon]="'searchIcon'" />

      <div class="divider-horizontal"></div>

      <div class="selected-items" #scrollContainer [class.has-scroll]="scrollContainerHasScroll()">
        @for (item of selectedDocumentsMap().values(); track item.id) {
          <component-chip
            icon="fileText"
            iconViewBox="0 0 20 20"
            [text]="item.title"
            [iconSize]="20"
            (remove)="onRemoveDocument(item)" />
        } @empty {
          Select documents to attach
        }
      </div>

      <div class="divider-horizontal"></div>

      <!-- TODO: refactor DocumentTree component to be able to display loading message -->
      @if (itemsToDisplay() === null) {
        <div class="p-3 text-muted loading-block">{{ hasSearchValue() ? "Searching..." : "Loading..." }}</div>
      } @else {
        <component-document-tree
          mode="Picker"
          [folderId]="''"
          [items]="itemsToDisplay() ?? []"
          [emptyMessage]="'No files to select'"
          [(selectedDocumentsMap)]="selectedDocumentsMap"
          [isPublicView]="false"
          [folderIds]="[]"
          [disableDrag]="true"
          [disableMove]="true"
          [expandAll]="false"
          [collapsed]="false"
          [isInPublicFolder]="false"
          [isCreateDisabled]="true"
          [hasContextMenu]="false"
          [allowPublicBadge]="false" />
      }
    </div>
  </ng-container>

  <ng-container footer>
    <div class="grid-auto-cols flex-grow-1 gap-3">
      <button type="button" class="btn btn-lg btn-light" (click)="activeModal.close()">Cancel</button>
      <button type="button" class="btn btn-lg btn-primary" (click)="onSubmit()">Attach</button>
    </div>
  </ng-container>
</component-modal>
